// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"424b8015","281":"ecce4765","519":"8ed3c032","660":"de5dfb37"}[chunkId] + ".chunk.js";
};